import * as React from "react";
import type { SVGProps } from "react";
const ChemicalPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M16 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-5 .5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m7 5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" clipRule="evenodd" /></svg>;
export default ChemicalPanelIcon;